export default __webpack_public_path__ + "static/ISOquality9001-footer-6aa6d4c8df1910b46b324af64ce233f2.png";